export const Arrayify = (array) => {
    return array !== undefined && array !== null && Array.isArray(array) ? array : []
}